module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Modal"
  }, [_c('div', {
    staticClass: "modal__mask",
    on: {
      "click": function($event) {
        _vm.toggleModal({
          isVisible: false,
          content: null,
          header: null
        })
      }
    }
  }, [_c('div', {
    staticClass: "modal__container card animated fadeIn",
    class: ("modal__container--" + (_vm.modal.size)),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleModal($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal__header"
  }, [_vm._v("\n        " + _vm._s(_vm.modal.header) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal__content"
  }, [_c(_vm.modal.content, {
    tag: "component"
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e4557ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/Modal/index.vue
// module id = 757
// module chunks = 3